
// CSS
import { Navigate, useHref, useNavigate } from "react-router-dom";
import "../Page/Page.css"
import "./ContentButton.css"

// React
import React from "react";


interface contentBtnObj {
  width?: string | number;
  children: React.ReactNode;
  click?: () => void;
}

const ContentButton: React.FC<contentBtnObj> = ({ width, children, click }) => {

  
  return (
    <div className="contentBtnContainer">
      <div className="contentBtnBackground" onClick={click } >
        <text className="contentBtn">
          {children}
        </text>
      </div>
    </div>
  );
};

export default ContentButton;



